import { Link } from "react-router-dom";

const TcsLogistics = () =>{
    return(
    <div>

        <div id='express' className="logistics-image">
            <img src='/LogisticsBanner/main-banner.jpg' alt='' className='w-[100%]'/>
        </div>
        <div className="flex flex-col justify-center  gap-4 lg:max-w-[50rem] max-w-[30rem] sm:max-w-[36rem] lg:mx-auto mx-[2rem] sm:mx-[auto]  lg:pr-[3rem] lg:pl-[3rem] lg:pt-[2rem] pt-[1rem]  pb-[1rem]">
            <p>
                With over four decades of excellence, over 18,000 corporate customers and the largest door-to-door 
                goods transportation business in Pakistan, TCS remains the leaders in logistics and supply chain. 
                From an extensive network of warehousing and distribution to one of the largest company-owned fleet 
                of primary and secondary distribution vehicles, TCS is undoubtedly the market leader when it comes 
                to facilitating and serving the largest corporations, as well as small and medium enterprises.
            </p>
                
        </div>
        <div className="max-w-[70rem] mx-auto  flex-col md:flex-row justify-between items-center py-[1.5rem] pb-[6rem]">
        <div className="lg:flex sm:flex grid sm:justify-center justify-bteween gap-6 flex-1 lg:pr-[2rem] ">
                <div className="flex justify-between flex-col gap-6">
                    <Link to="/overland-logistics" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[10px] py-[12px] rounded-md'> 
                        <img src='/Home/expressIcons/overlandexpress.svg' className='w-[100px] tcs-express-logo'/>
                    </Link>
                    <Link to="/warehousing" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[22px] py-[18px] rounded-md'> 
                        <img src='/Home/expressIcons/warehousing.svg' className='w-[100px] '/>
                    </Link>
                    <Link to="/international-freights" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[22px] py-[12px] rounded-md'> 
                        <img src='/Home/expressIcons/intfreight.svg' className='w-[100px] tcs-express-logo'/>
                    </Link>
                    <Link to="/pack-n-go" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[22px] py-[18px] rounded-md'> 
                        <img src='/Home/expressIcons/packngo.svg' className='w-[85px] h-[13px]'/>
                    </Link>
                    <Link to="/project-logistics" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[14px] py-[12px] rounded-md'> 
                        <img src='/Home/expressIcons/projectlogistics.svg' className='w-[100px] tcs-express-logo'/>
                    </Link>
                    <Link to="/agri-logistics" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[14px] py-[12px] rounded-md'> 
                        <img src='/Home/expressIcons/agrilogistics.svg' className='w-[100px] tcs-express-logo'/>
                    </Link>
                </div>
                
                <div className="flex flex-col gap-6">

                    <Link to="/fleet-transportation" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[22px] py-[12px] rounded-md'> 
                        <img src='/Home/expressIcons/fleetransportation.svg' className='w-[100px] tcs-express-logo'/>
                    </Link>
                    <Link to="/distribution" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[24px] py-[19px] rounded-md'> 
                        <img src='/Home/expressIcons/distribution.svg' className='w-[100px]'/>  
                    </Link>
                    <Link to="/customs-bokerage" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[18px] py-[12px] rounded-md'> 
                        <img src='/Home/expressIcons/customsbrokerage.svg' className='w-[100px] tcs-express-logo'/>  
                    </Link>
                    <Link to="/expo-logistics" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[10px] py-[12px] rounded-md'> 
                        <img src='/Home/expo-logistics.svg' className='w-[100px] tcs-express-logo'/>  
                    </Link>
                    <Link to="/coldchain" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[24px] py-[18px] rounded-md'> 
                        <img src='/Home/expressIcons/coldchain.svg' className='w-[85px]'/> 
                    </Link>
                    <Link to="/regional-trade" className='shadow-card lg:w-[20rem] md:w-[17rem] w-[16rem] sm:mx-[0rem] mx-[2rem] px-[24px] py-[12px] rounded-md'> 
                        <img src='/Home/expressIcons/tirregionaltrade.svg' className='w-[110px] tcs-express-logo'/> 
                    </Link>

                                            
                
                </div>
            </div>
            
        </div>
    </div>
    )
};
export default TcsLogistics